"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTemplateMaxWidth = exports.getPlaceholderStyles = exports.setDistance = exports.DISTANCE_KEYS = exports.setInputMetrics = exports.setInputAppearance = exports.setGrabCursor = exports.setBorderRadius = exports.percentToVW = exports.toPercent = exports.toPx = exports.uiLayerShadow = exports.singleDirectionModuleSpacing = exports.uiFocus = exports.setUiTransition = exports.FONT_FAMILIES = exports.setFontStack = exports.setFontSmoothing = exports.setFontSize = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = require("styled-components");

var _Color = require("../core/Color");

var _Style = require("../core/Style");

var _misc = require("HubStyleTokens/misc");

var _sizes = require("HubStyleTokens/sizes");

var _colors = require("HubStyleTokens/colors");

var _theme = require("HubStyleTokens/theme");

var _times = require("HubStyleTokens/times");

function _templateObject13() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-left: auto;\n  margin-right: auto;\n  max-width: ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  &::-moz-placeholder {\n    opacity: 1;\n    ", ";\n  }\n  &:-ms-input-placeholder {\n    ", ";\n  }\n  &::-webkit-input-placeholder {\n    ", ";\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          @media only screen and (max-width: ", ") {\n            width: 100%;\n          }\n        "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding-bottom: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    padding-top: ", ";\n    ", ";\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: block;\n  height: ", ";\n  width: 100%;\n  font-size: ", ";\n  line-height: 22px;\n  text-align: left;\n  vertical-align: ", ";\n  color: ", ";\n  background-color: ", ";\n  border: ", " solid ", ";\n  border-radius: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  cursor: move; /* Fallback for IE11 */\n  cursor: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-radius: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  box-shadow: 0 ", " ", " 0\n    ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-bottom: ", ";\n    margin-top: 0;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  box-shadow: ", "\n      ", ",\n    ", " ", " !important;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    transition: ", " ", " ease-out;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var setFontSize = function setFontSize(size) {
  return (0, _styledComponents.css)(_templateObject(), (0, _Style.remCalc)(size));
};

exports.setFontSize = setFontSize;

var setFontSmoothing = function setFontSmoothing(smoothing) {
  var computedSmoothing = smoothing || 'antialiased'; // No `css` wrapper for this mixin, due to a bug in styled-components v3

  return "\n    -webkit-font-smoothing: " + computedSmoothing + ";\n    -moz-osx-font-smoothing: " + (computedSmoothing === 'antialiased' ? 'grayscale' : computedSmoothing) + ";\n  ";
}; // note: just a template literal, not using css function


exports.setFontSmoothing = setFontSmoothing;

var setFontStack = function setFontStack(family) {
  return "\n  font-family: '" + family + "', " + _misc.FALLBACK_FONT_STACK + ";\n";
};

exports.setFontStack = setFontStack;
var FONT_FAMILIES = {
  bold: function bold() {
    return "\n        " + setFontStack(_misc.WEB_FONT_BOLD) + ";\n        font-weight: " + _misc.WEB_FONT_BOLD_WEIGHT + ";\n      ";
  },
  demibold: function demibold() {
    return "\n        " + setFontStack(_misc.WEB_FONT_DEMI_BOLD) + ";\n        font-weight: " + _misc.WEB_FONT_DEMI_BOLD_WEIGHT + ";\n      ";
  },
  medium: function medium() {
    return "\n        " + setFontStack(_misc.WEB_FONT_MEDIUM) + ";\n        font-weight: " + _misc.WEB_FONT_MEDIUM_WEIGHT + ";\n      ";
  },
  italic: function italic() {
    return "\n        " + setFontStack(_misc.WEB_FONT_ITALIC) + ";\n        font-style: italic;\n        font-weight: " + _misc.WEB_FONT_ITALIC_WEIGHT + ";\n      ";
  },
  default: function _default() {
    return "\n        " + setFontStack(_misc.WEB_FONT_REGULAR) + ";\n        font-weight: " + _misc.WEB_FONT_REGULAR_WEIGHT + ";\n      ";
  }
};
exports.FONT_FAMILIES = FONT_FAMILIES;

var setUiTransition = function setUiTransition(property, timing) {
  var computedTiming = timing || _times.MICRO_TRANSITION_TIMING;
  var computedProperty = property || 'all';
  return (0, _styledComponents.css)(_templateObject2(), computedProperty, computedTiming);
};
/**
 * A mixin that simulates focus styling. Needed when the semantic element with the focus is hidden,
 * such as the `<input>` in `UICheckbox`.
 */


exports.setUiTransition = setUiTransition;
var uiFocus = (0, _styledComponents.css)(_templateObject3(), _sizes.FOCUS_RING_SHADOW_SIZES, (0, _Color.rgba)(_colors.FOCUS_RING_BASE, _sizes.FOCUS_RING_SHADOW_ALPHA), _sizes.FOCUS_RING_SHADOW_LAST_SIZES, _colors.FOCUS_RING_BASE);
exports.uiFocus = uiFocus;

var singleDirectionModuleSpacing = function singleDirectionModuleSpacing(size) {
  var computedSize = size || parseInt(_sizes.BASE_SINGLE_DIRECTION_MARGIN, 10);
  return (0, _styledComponents.css)(_templateObject4(), (0, _Style.remCalc)(computedSize));
};

exports.singleDirectionModuleSpacing = singleDirectionModuleSpacing;

var uiLayerShadow = function uiLayerShadow() {
  return (0, _styledComponents.css)(_templateObject5(), _sizes.BASE_SHADOW_OFFSET_Y, _sizes.BASE_SHADOW_BLUR_RADIUS, (0, _Color.rgba)(_theme.BASE_SHADOW_COLOR, parseFloat(_sizes.BASE_SHADOW_ALPHA)));
};

exports.uiLayerShadow = uiLayerShadow;

var toPx = function toPx(value) {
  return typeof value === 'number' ? value + "px" : value;
};

exports.toPx = toPx;

var toPercent = function toPercent(value) {
  return value == null ? undefined : value + "%";
};

exports.toPercent = toPercent;

var percentToVW = function percentToVW(width) {
  if (typeof width !== 'string') return width;
  return width.replace(/(\d+)%/g, '$1vw');
};

exports.percentToVW = percentToVW;

var setBorderRadius = function setBorderRadius() {
  var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _sizes.BUTTON_RADIUS;
  return (0, _styledComponents.css)(_templateObject6(), toPx(radius));
};

exports.setBorderRadius = setBorderRadius;

var setGrabCursor = function setGrabCursor() {
  var cursor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'grab';
  return (0, _styledComponents.css)(_templateObject7(), cursor);
};

exports.setGrabCursor = setGrabCursor;

var setInputAppearance = function setInputAppearance() {
  return (0, _styledComponents.css)(_templateObject8(), _sizes.INPUT_DEFAULT_HEIGHT, _sizes.INPUT_FONT_SIZE, _misc.INPUT_VERTICAL_ALIGNMENT, _theme.FORM_CONTROL_FOREGROUND_COLOR, _theme.FORM_CONTROL_BACKGROUND_COLOR, _sizes.INPUT_BORDER_WIDTH, _theme.FORM_CONTROL_BORDER_COLOR, _sizes.BUTTON_RADIUS);
};

exports.setInputAppearance = setInputAppearance;

var setInputMetrics = function setInputMetrics() {
  var padVertical = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _sizes.BUTTON_DEFAULT_PADDING_Y;
  var padHorizontal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _sizes.BUTTON_DEFAULT_PADDING_X;
  var padRight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : padHorizontal;
  var padBottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : padVertical;
  var responsive = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  return (0, _styledComponents.css)(_templateObject9(), toPx(padBottom), toPx(padHorizontal), toPx(padRight), toPx(padVertical), responsive ? (0, _styledComponents.css)(_templateObject10(), _sizes.GRID_BREAKPOINT_SMALL) : null);
};

exports.setInputMetrics = setInputMetrics;
var DISTANCE_SIZES = {
  flush: 0,
  'extra-small': _sizes.DISTANCE_MEASUREMENT_EXTRA_SMALL,
  small: _sizes.DISTANCE_MEASUREMENT_SMALL,
  medium: _sizes.DISTANCE_MEASUREMENT_MEDIUM,
  large: _sizes.DISTANCE_MEASUREMENT_LARGE,
  'extra-large': _sizes.DISTANCE_MEASUREMENT_EXTRA_LARGE
};
var DISTANCE_KEYS = Object.keys(DISTANCE_SIZES);
exports.DISTANCE_KEYS = DISTANCE_KEYS;

var setDistance = function setDistance() {
  var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medium';
  var size = DISTANCE_SIZES[distance];
  return (0, _styledComponents.css)(_templateObject11(), size, size);
};
/**
 * Given styles, wraps them in selectors to apply to placeholder text in an input or textarea.
 */


exports.setDistance = setDistance;

var getPlaceholderStyles = function getPlaceholderStyles(styles) {
  return (0, _styledComponents.css)(_templateObject12(), styles, styles, styles);
};
/**
 * @returns a mixin that sets the appropriate width and margins to match a page template with
 * `pageLayout="max-width"`.
 */


exports.getPlaceholderStyles = getPlaceholderStyles;

var setTemplateMaxWidth = function setTemplateMaxWidth() {
  return (0, _styledComponents.css)(_templateObject13(), toPx(parseInt(_sizes.LAYOUT_MAX_WIDTH, 10) + parseInt(_sizes.LAYOUT_PADDING_X, 10) * 2));
};

exports.setTemplateMaxWidth = setTemplateMaxWidth;